// engine
import { ArController } from '@aceroll/core';

// hacksaw
import { responseService } from '@aceroll/platform-hacksaw';

import { platform } from '../../platform';

export class EvMaxWin extends ArController {
    onStart() {
        platform.setMaxWin();
        // const serverEvent = responseService.getEvent();
        responseService.completeEvent();
        this.stop();
    }
}
